import { delay, buffers } from 'redux-saga';
import { saveState, sendData, serialize } from './fetch';
import {
  PREVIEW,
} from './actions/action-names';

import {
  take,
  call,
  fork,
  race,
  select,
  cancel,
  cancelled,
  actionChannel,
} from 'redux-saga/effects';

let isSaving = false;

window.addEventListener('beforeunload', e => {
  if (isSaving) {
    const message = `Autosaving is not completed yet. Please wait for some seconds before leaving this PAGE.`;
    e.returnValue = message;
    return message;
  }
});

function* debounce(ms, pattern, task, ...args) {
  const debounceChannel = yield actionChannel(pattern, buffers.sliding(1));
  let lastAction, currentTask;

  while (true) {
    const { action, timeout } = yield race({
      action: take(debounceChannel),
      timeout: call(delay, ms)
    });

    if (action) {
      if (currentTask && currentTask.isRunning()) {
        yield cancel(currentTask);
      }

      lastAction = action;
      isSaving = true;
    } else if (lastAction) {
      currentTask = yield fork(task, ...args, lastAction);
      lastAction = undefined;
    }
  }
}

export function* autoSave() {
  let xhr;

  try {
    const state = yield select();
    const currentState = {
      ...state,
      model: {
        ...state.model,
        desktop: {
          past: [],
          future: [],
          present: state.model.desktop.present
        },
        tablet: {
          past: [],
          future: [],
          present: state.model.tablet.present
        },
        mobile: {
          past: [],
          future: [],
          present: state.model.mobile.present
        },
      }
    };

    /**
     * Directly assign the return value of this function
     * to the xhr variable, because the cancel function
     * added to it directly.
     */
    xhr = saveState(currentState);
    yield xhr;

    isSaving = false;
  } catch (ex) {
    console.error(ex);
  } finally {
    if (yield cancelled()) {
      xhr.cancel();
    }
  }
};

export function* debounceAutoSave() {
  yield debounce(1000, action => action.type !== PREVIEW, autoSave);
};

export function* preview() {
  let xhr;

  while (true) {
    yield take(PREVIEW);

    // if (xhr) {
    //   xhr.cancel();
    //   xhr = undefined;
    // }

    // const state = yield select();
    // xhr = saveState(state);

    window.open('../?header-builder=preview');

    // xhr.then(() => {
    //   console.log('now open the page.');
    // });
  }
};

export default function* rootSaga() {
  yield [
    debounceAutoSave(),
    preview(),
  ];
};



// WEBPACK FOOTER //
// ./app/header-builder/sagas.js